/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-05T16:23:43.425
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveEnergyRecordItem,
	getEnergyRecordItemCreateInit,
	getEnergyRecordItemEditInit,
	getEnergyRecordItemView,
	deleteEnergyRecordItem
} from '@api/rentmanage/EnergyRecordItem';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getEnergyRecordItemCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getEnergyRecordItemCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getEnergyRecordItemEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getEnergyRecordItemEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveEnergyRecordItem({}, EnergyRecordItem) {
			return new Promise((resolve, reject) => {
				saveEnergyRecordItem(EnergyRecordItem)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getEnergyRecordItemView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getEnergyRecordItemView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteEnergyRecordItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteEnergyRecordItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
